"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./palette.scss");
//# sourceMappingURL=index.js.map